<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-position`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 3c8.284 0 15 6.705 15 14.976C39 23.49 34 30.498 24 39 14 30.498 9 23.49 9 17.976 9 9.706 15.716 3 24 3zm7.259 34.833l2.984-2.983C36.561 36.071 38 37.776 38 39.868c0 4.411-6.381 7.15-14 7.15s-14-2.739-14-7.15c0-1.992 1.284-3.62 3.401-4.826l2.985 2.988C14.772 38.704 14 39.453 14 39.868c0 .392.721 1.124 2.303 1.803 1.971.846 4.729 1.346 7.697 1.346s5.726-.5 7.697-1.346c1.582-.679 2.303-1.41 2.303-1.803 0-.321-.513-.914-1.717-1.529-.366-.187-.75-.377-1.024-.506zM13 17.976C13 11.916 17.923 7 24 7s11 4.916 11 10.976c0 3.59-3.585 8.97-11 15.703-7.415-6.732-11-12.113-11-15.703zM24 11a7 7 0 110 14 7 7 0 010-14zm-3 7a3 3 0 116 0 3 3 0 01-6 0z"/></svg>
</template>
<script>

export default {
  name: 'IconPosition',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
